// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/app/:slug*?\",\"regex\":\"^/app(?:/(.*))?$\",\"paramNames\":[\"slug\"]},{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"]},{\"path\":\"/c/:callLogId\",\"regex\":\"^/c/([^/]+)$\",\"paramNames\":[\"callLogId\"]},{\"path\":\"/help-center/:slug\",\"regex\":\"^/help-center/([^/]+)$\",\"paramNames\":[\"slug\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/ai-receptionist-for-coffee-shops\"},{\"path\":\"/ai-receptionist-pricing\"},{\"path\":\"/answering-service-for-plumbers\"},{\"path\":\"/blog\"},{\"path\":\"/features\"},{\"path\":\"/forgot-password\"},{\"path\":\"/hardscape-contractors\"},{\"path\":\"/help-center\"},{\"path\":\"/industries\"},{\"path\":\"/landscapers\"},{\"path\":\"/landscaping-answering-service\"},{\"path\":\"/locksmith\"},{\"path\":\"/login\"},{\"path\":\"/never-miss-a-call\"},{\"path\":\"/plumbing\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy\"},{\"path\":\"/register\"},{\"path\":\"/registration-complete\"},{\"path\":\"/reset-password\"},{\"path\":\"/restaurants\"},{\"path\":\"/salon\"},{\"path\":\"/salon-answering-service\"},{\"path\":\"/status\"},{\"path\":\"/terms\"},{\"path\":\"/try\"}]}";globalThis["_sentryNextJsVersion"] = "16.1.1";import { browserProfilingIntegration, browserTracingIntegration, captureRouterTransitionStart, init, replayIntegration } from "@sentry/nextjs";

import { isAdmin, isProduction } from "./lib/mixpanel";


// Build integrations array conditionally
const integrations = [
  browserTracingIntegration(),
  browserProfilingIntegration(),
];

// Only add replay integration in production
if (isProduction()) {
  integrations.push(
    replayIntegration({
      // Disable masking - send all text and fields in recordings
      maskAllText: false,
      blockAllMedia: false,
    })
  );
}

init({
  dsn: "https://6b5366fac7b119b27e84cca65ce38a4a@o4509976819728384.ingest.us.sentry.io/4509976821170176",

  // Add optional integrations for additional features
  integrations,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1.0,

  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/.*\.vercel\.app\/api/, /^http:\/\/localhost:8000\/api/, /^https:\/\/usegreet\.com\/api/, /^https:\/\/beta\.usegreet\.com\/api/],

  // Set sampling rate for profiling - this is evaluated only once per SDK.init call
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  profilesSampleRate: 1.0,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // Only enable if in production and user is not admin
  // Check admin status at initialization - will be stopped later if admin logs in
  replaysSessionSampleRate: isProduction() && !isAdmin() ? 0.1 : 0,

  // Define how likely Replay events are sampled when an error occurs.
  // Only enable if in production and user is not admin
  // Check admin status at initialization - will be stopped later if admin logs in
  replaysOnErrorSampleRate: isProduction() && !isAdmin() ? 1.0 : 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = captureRouterTransitionStart;